export const dedupeArray = <T>(values: Array<T>): Array<T> => {
  const temp = Array.from(new Set(values))

  return temp
}
